import { useEffect, useState } from 'react'

import { useAccountInfo } from '@context/AccountInfoContext/AccountInfoContext.Provider'
import { useProductReadContext } from '@context/ProductContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { NameDto } from '@model/NameDto'
import { TradingAccountPlatformTypesOptions } from '@model/TradingAccountCreationOptions'
import { CurrencyType } from '@model/WalletDto'

import { CreateTradingAccountCampaignFormProps } from '../CreateTradingAccountCampaign.types'

export const useTradingAccountCreationOptionsFetch = (
  props: CreateTradingAccountCampaignFormProps
) => {
  const { values } = props
  const apiClient = useApiClient(ClientApiClient)
  const { product } = useProductReadContext()
  const { accountInfo } = useAccountInfo()

  const [campaignType, setCampaignType] = useState<NameDto | undefined>()
  const [campaignCurrencies, setCampaignCurrencies] = useState<CurrencyType[]>([])
  const [platformTypes, setPlatformTypes] = useState<TradingAccountPlatformTypesOptions>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setCampaignType(props.data.find((campaign) => campaign.id === values.campaignId)?.type)
    const fetchTradingAccountCreationOptions = async () => {
      setIsLoading(true)

      const getRegularAccountPlatforms = () => {
        const filteredPlatforms = accountInfo
          ?.filter((info) => info.product.id === product)
          .map((info) => ({ id: info.platform.id, name: info.platform.name }))
        setPlatformTypes(filteredPlatforms ?? [])
      }
      try {
        if (values.campaignId) {
          const creationOptions = await apiClient.getTradingAccountCreationOptions(
            values.campaignId,
            { platformTypeId: values.platformType?.id.toString() }
          )
          setCampaignCurrencies(creationOptions.currencies)
          setPlatformTypes(creationOptions.platformTypes)
        } else {
          getRegularAccountPlatforms()
        }
      } finally {
        setIsLoading(false)
      }
    }
    fetchTradingAccountCreationOptions()
  }, [values.campaignId, values.platformType, apiClient, accountInfo, product, props.data])

  return { campaignType, campaignCurrencies, platformTypes, isLoading }
}
